import React from 'react';

import { Button, ButtonProps } from '@chakra-ui/react';

import { CheckCircle } from 'assets/assetsV1/iconComponents';

const InstalledButton = ({ children, ...props }: ButtonProps) => (
  <Button
    color="functional.44812F"
    bgColor="functional.DBF2D3"
    leftIcon={<CheckCircle color="functional.44812F" boxSize="20px" />}
    w="143px"
    boxShadow="0px 0px 1px 0px rgba(0, 0, 0, 0.25)"
    sx={{
      '&[disabled]': {
        opacity: '1',
        pointerEvents: 'none',
        boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.25)',
      },
    }}
    {...props}
  >
    {children}
  </Button>
);

export default InstalledButton;
